export class Parameter {
    name: string;
    value: string;
}

export const ROWPERPAGE_OPTIONS: string[] = ['10', '20', '30', '40', '50'];
